<template>
  <component
    :is="tagCompute"
    :to="to"
    :href="href"
    :target="target"
    class="breadcrumb-container inline-block mt-16"
    @click="clickEmitter"
  >
    <div v-if="header" class="flex flex-row items-center breadcrumb">
      <ArrowHead style="transform: scaleX(-1)" class="mr-8" />
      <span>{{ header }}</span>
    </div>
  </component>
</template>

<script lang="ts">
import Vue from 'vue';
import ArrowHead from '../../icons/ArrowHead.vue';

export default Vue.extend({
  name: 'Breadcrumb',
  components: { ArrowHead },
  props: {
    header: {
      default: '',
      type: String,
    },
    to: {
      default: '',
      type: String,
    },
    href: {
      default: '',
      type: String,
    },
    target: {
      default: '',
      type: String,
    },
    anchorLink: {
      default: false,
      type: Boolean,
    },
    isButton: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    tagCompute() {
      if (this.to) return 'router-link';
      if (this.anchorLink) return 'a';
      if (this.isButton) return 'button';
      return 'div';
    },
  },
  methods: {
    clickEmitter(e) {
      this.$emit('click', e);
    },
  },
});
</script>

<style scoped lang="scss">
.breadcrumb-container {
  position: relative;
  outline: none;
  &:focus-visible {
    // simulates hover effect with keyboard focus
    .breadcrumb,
    .breadcrumb svg path {
      color: theme('colors.brand.contrast');
      fill: theme('colors.brand.contrast');
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border: 2px dotted theme('colors.brand.contrast');
      margin: -4px;
      border-radius: theme('borderRadius.lg');
    }
  }
}

.breadcrumb {
  color: theme('colors.primary.DEFAULT');
  &:hover,
  &:hover svg path {
    color: theme('colors.brand.contrast');
    fill: theme('colors.brand.contrast');
  }
}
</style>
